import { Box, Typography } from '@mui/material';
import { WizardTextField } from './WizardTextField';
import { WizardNumericField } from './WizardNumericField';
import { WizardUrlFieldWithParameters } from './WizardUrlFieldWithParameters';

const CampaignOfferSettings = () => {
  return (
    <Box display="flex" flexDirection="column" gap={2} mt={2}>
      <Typography variant="h6" gutterBottom>
        Offer Settings
      </Typography>

      <WizardTextField label="Merchant ID" name="merchantId" />

      <WizardTextField label="Merchant Name" name="merchantName" />

      <WizardTextField label="Merchant URL" name="merchantUrl" />

      <WizardUrlFieldWithParameters label="Affiliate URL" name="affiliateUrl" />

      <WizardNumericField label="Click Cap" name="clickCap" />

      <WizardNumericField label="Commission" name="commission" float />

      <WizardTextField label="Geo" name="geo" />

      <WizardTextField label="Device" name="device" />
    </Box>
  );
};

export default CampaignOfferSettings;
